"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORTEX_CODE_CLI_ALLOWED_REGIONS = exports.SignupFlowsOnNewDesign = exports.VALID_COCO_SUBSCRIPTION_PROMO_PROGRAMS = exports.RiskClassAtSignup = exports.ActivationSource = exports.SignupFlowType = void 0;
exports.isCocoSubscriptionPromoFlow = isCocoSubscriptionPromoFlow;
exports.isCocoSubscriptionPromoProgram = isCocoSubscriptionPromoProgram;
exports.isCortexCodeFlow = isCortexCodeFlow;
var SignupFlowType;
(function (SignupFlowType) {
    SignupFlowType["Default"] = "Default";
    SignupFlowType["Developer"] = "Developer";
    SignupFlowType["Lab"] = "Lab";
    SignupFlowType["Listing"] = "Listing";
    SignupFlowType["Startup"] = "Startup";
    SignupFlowType["Student"] = "Student";
    SignupFlowType["Learn"] = "Learn";
    SignupFlowType["SalesAssisted"] = "SalesAssisted";
    SignupFlowType["AccountExecutive"] = "AccountExecutive";
    SignupFlowType["Unknown"] = "Unknown";
    SignupFlowType["Azure"] = "Azure";
    SignupFlowType["Gcp"] = "Gcp";
    SignupFlowType["AwsOnDemand"] = "AwsOnDemand";
    SignupFlowType["AwsCapacity"] = "AwsCapacity";
    SignupFlowType["AwsOnDemandAddSubscription"] = "AwsOnDemandAddSubscription";
    SignupFlowType["Streamlit"] = "Streamlit";
    SignupFlowType["CortexRestApi"] = "CortexRestApi";
    SignupFlowType["CortexCodeCLI"] = "CortexCodeCLI";
    SignupFlowType["CocoSubscriptionPromo"] = "CocoSubscriptionPromo";
})(SignupFlowType || (exports.SignupFlowType = SignupFlowType = {}));
/**
 * Activation source written to OrganizationDPO.activationSource at account creation time.
 * Read by Snowsight and downstream systems to categorize the account post creation.
 *
 * These string values are a wire contract with the consumer: do not rename without
 * coordinating the change on the reader side.
 *
 * `Unknown` is written when the signup does not map to any of the known sources, so every
 * signup going forward receives an activation source rather than a missing field. This is a
 * new field: accounts created prior to mid-July 2026 may not have it set.
 */
var ActivationSource;
(function (ActivationSource) {
    ActivationSource["DefaultTrial"] = "DefaultTrial";
    ActivationSource["HandsOnLab"] = "HandsOnLab";
    ActivationSource["CortexCodeCLI"] = "CortexCodeCLI";
    ActivationSource["CocoSubscriptionPromo"] = "CocoSubscriptionPromo";
    ActivationSource["CocoSubscription"] = "CocoSubscription";
    ActivationSource["DeveloperSignup"] = "DeveloperSignup";
    ActivationSource["SnowflakeMarketplaceListing"] = "SnowflakeMarketplaceListing";
    ActivationSource["StudentSignup"] = "StudentSignup";
    // Legacy training and learning initiatives that are not treated as today's Hands on Labs
    // because they were not specifically run by Snowflake.
    ActivationSource["LegacyLearning"] = "LegacyLearning";
    ActivationSource["StartupCompetition"] = "StartupCompetition";
    // A signup initiated by a Snowflake employee (the `eng` field, validated against Snowhouse).
    ActivationSource["SalesAssisted"] = "SalesAssisted";
    // An account-executive signup, which carries only an unvalidated `owner`. Distinct from
    // SalesAssisted because it is not an employee-validated signup.
    ActivationSource["AccountExecutive"] = "AccountExecutive";
    ActivationSource["AwsMpOnDemand"] = "AwsMpOnDemand";
    // Written when a signup does not map to any of the sources above (a warning is logged).
    ActivationSource["Unknown"] = "Unknown";
})(ActivationSource || (exports.ActivationSource = ActivationSource = {}));
/**
 * Trust signal written to OrganizationDPO.riskClassAtSignup at account creation time.
 * GS only accepts these four values (Organization.ALLOWED_RISK_CLASSES_AT_SIGNUP).
 */
var RiskClassAtSignup;
(function (RiskClassAtSignup) {
    RiskClassAtSignup["Low"] = "low";
    RiskClassAtSignup["Medium"] = "medium";
    RiskClassAtSignup["High"] = "high";
    RiskClassAtSignup["Unspecified"] = "unspecified";
})(RiskClassAtSignup || (exports.RiskClassAtSignup = RiskClassAtSignup = {}));
/**
 * True for the CoCo subscription promo flow (approved program signups that get a
 * free CoCo subscription for COCO_SUBSCRIPTION_PROMO_DURATION_MONTHS before they are
 * charged for a paid subscription). These subscriptions do not have a trial period.
 */
function isCocoSubscriptionPromoFlow(signupFlowType) {
    return signupFlowType === SignupFlowType.CocoSubscriptionPromo;
}
/**
 * Valid values of the `?program=` signup URL param for the CoCo subscription promo, stored as
 * `program_key` in COCO_SUBS_PROMO_APPROVED_USERS. Any other value, or a repeated `program` param,
 * is ignored, so the signup falls back to the regular signup page.
 */
exports.VALID_COCO_SUBSCRIPTION_PROMO_PROGRAMS = [
    'scc_coco',
    'dbt_coco',
    'startup_coco',
    'student_coco',
];
function isCocoSubscriptionPromoProgram(program) {
    return (typeof program === 'string' &&
        exports.VALID_COCO_SUBSCRIPTION_PROMO_PROGRAMS.includes(program));
}
/**
 * True for any flow that signs the user up for Snowflake CoCo (Cortex Code). The
 * CocoSubscriptionPromo flow shares the CortexCodeCLI signup experience (regions, form,
 * account setup), so checks that apply to CortexCodeCLI should generally use this helper.
 */
function isCortexCodeFlow(signupFlowType) {
    return (signupFlowType === SignupFlowType.CortexCodeCLI || isCocoSubscriptionPromoFlow(signupFlowType));
}
exports.SignupFlowsOnNewDesign = [
    SignupFlowType.Default,
    SignupFlowType.Developer,
    SignupFlowType.Lab,
    SignupFlowType.Listing,
    SignupFlowType.Startup,
    SignupFlowType.Student,
    SignupFlowType.Learn,
    SignupFlowType.AccountExecutive,
    SignupFlowType.Streamlit,
    SignupFlowType.CortexRestApi,
    SignupFlowType.CortexCodeCLI,
    SignupFlowType.CocoSubscriptionPromo,
    // SalesAssisted = 'SalesAssisted',
    // Unknown = 'Unknown',
    // Azure = 'Azure',
    // Gcp = 'Gcp',
    // AwsOnDemand = 'AwsOnDemand',
    // AwsCapacity = 'AwsCapacity',
    // AwsOnDemandAddSubscription = 'AwsOnDemandAddSubscription',
];
/**
 * Allowed AWS regions for Cortex Code CLI signup flow.
 * These regions support Cortex cross-region functionality and are mapped to
 * three cross-region groups: AWS_US, AWS_EU, and AWS_APJ.
 */
exports.CORTEX_CODE_CLI_ALLOWED_REGIONS = [
    // Dev regions for local testing
    'preprod8',
    'reg',
    // AWS US
    'us-east-1',
    'us-east-2',
    'us-west-2',
    // AWS EU
    'eu-central-1',
    'eu-central-2',
    'eu-north-1',
    'eu-west-1',
    'eu-west-2',
    'eu-west-3',
    // AWS APJ (Asia Pacific + Japan)
    'ap-northeast-1',
    'ap-northeast-2',
    'ap-northeast-3',
    'ap-south-1',
    'ap-southeast-1',
    'ap-southeast-2',
    'ap-southeast-3',
];
//# sourceMappingURL=signupFlows.js.map